import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./RangeDatePicker.scss";
import "react-datepicker/dist/react-datepicker.css";
import CustomDayPicker from "./CustomDatPicker";
import ValidationMessege from "../Autocomplete/assets/ValidationMessege";

type RangeDatePickerProps = {
  initialStartDate?: Date;
  initialEndDate?: Date;
  onStartDateChange?: (date: Date) => void;
  onEndDateChange?: (date: Date) => void;
  defaultStartDate?: Date;
  defaultEndDate?: Date;
  toResetDates?: boolean;
};

// TODO: when merge drop3 to check if this component is still relevant to the reports filters
const RangeDatePicker = ({
  initialStartDate,
  initialEndDate,
  onStartDateChange,
  onEndDateChange,
  defaultStartDate = new Date(),
  defaultEndDate = new Date(),
  toResetDates,
}: RangeDatePickerProps) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(initialStartDate);
  const [endDate, setEndDate] = useState(initialEndDate);
  const [error, setError] = useState("");

  useEffect(() => {
    if (toResetDates) {
      setStartDate(null);
      setEndDate(null);
    }
  }, [toResetDates]);

  const handleDateChange = useCallback(
    (date, type) => {
      if (type === "start") {
        if (endDate && date && date > endDate) {
          setError(t("validationStartDateLaterThanEndDate"));
          return;
        }
        const dateToUpdate = date ?? defaultStartDate;
        setStartDate(date);
        onStartDateChange(dateToUpdate);
      }

      if (type === "end") {
        if (startDate && date && date < startDate) {
          setError(t("validationEndDateEarlierThanStartDate"));
          return;
        }
        const dateToUpdate = date ?? defaultEndDate;
        setEndDate(date);
        onEndDateChange(dateToUpdate);
      }
    },
    [
      t,
      defaultStartDate,
      onStartDateChange,
      defaultEndDate,
      onEndDateChange,
      startDate,
      endDate,
    ]
  );

  return (
    <div>
      <div className="rangeDatePickerContainer">
        <CustomDayPicker
          datePickerName="start"
          selectedDate={startDate}
          onChange={(date) => handleDateChange(date, "start")}
          defaultDate={defaultStartDate}
          error={error}
          setError={setError}
          portalId="root-portal" // this solves the problem that the datepicker doesn't overflow out from the container if the container have "overflow-y: scroll"
        />
        -
        <CustomDayPicker
          datePickerName="end"
          selectedDate={endDate}
          onChange={(date) => handleDateChange(date, "end")}
          defaultDate={defaultEndDate}
          error={error}
          setError={setError}
          portalId="root-portal" // this solves the problem that the datepicker doesn't overflow out from the container if the container have "overflow-y: scroll"
        />
      </div>
      {error && (
        <ValidationMessege
          className="validation"
          validationMessage={error}
          validationMessageClass="error"
        />
      )}
    </div>
  );
};
export default RangeDatePicker;
